import { graphql } from '../../graphql';

export const createInvoiceMutation = graphql(`
  mutation CreateInvoiceForPackage(
    $activationType: InvoiceCreateForPackageActivationTypeEnum!
    $name: String!
    $period: Int!
    $startsAt: Date
    $platform: PlatformEnum
  ) {
    createInvoiceForPackage(
      input: {
        activationType: $activationType
        name: $name
        period: $period
        startsAt: $startsAt
      }
    ) {
      errors {
        code
        message
        path
      }
      invoice {
        id
        status
        amount
        packageDescription
        paidServices {
          id
          activeUntil
          title
          targetType
          options {
            id
            name
            price
            priceWithDiscount(paymentMethodId: "wallet")
          }
          paymentMethods(platform: $platform) {
            id
            balance
            name
            cardToken
            iconUrl
            isAppleGooglePayEnabled
          }
        }
      }
    }
  }
`);
